const SECTIONS = [
  { label: "编辑推荐", href: "#编辑推荐" },
  { label: "每日精选", href: "#每日精选" },
  { label: "秘书严选", href: "#秘书严选" },
  { label: "本月热荐", href: "#本月热荐" },
  { label: "编辑私藏", href: "#编辑私藏" },
];

const RESOURCES = [
  { label: "关于小秘", href: "#关于" },
  { label: "常见问题", href: "#常见问题" },
  { label: "订阅周刊", href: "#订阅" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-800 text-primary-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-lg text-primary-600">
                <i className="ri-book-2-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">小秘漫画网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100">
              你的私人漫画小秘书。编辑推荐、每日精选、秘书严选冷门佳作，还有本月热荐与编辑私藏，
              帮你在海量漫画里快速找到值得一读的那一部。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="社交入口"
                  className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-700 text-primary-50 transition-colors hover:bg-primary-600"
                >
                  <i className={icon} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">推荐栏目</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {SECTIONS.map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-primary-100 transition-colors hover:text-background-50">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">了解更多</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {RESOURCES.map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-primary-100 transition-colors hover:text-background-50">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="mailto:hello@xiaomi-comic.cn"
              className="mt-4 inline-flex items-center gap-2 text-sm text-primary-100 transition-colors hover:text-background-50"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              hello@xiaomi-comic.cn
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-primary-700 pt-6 sm:flex-row">
          <p className="text-xs text-primary-100">
            © {year} 小秘漫画网 · 只为让你轻松找到好漫画
          </p>
          <p className="text-xs text-primary-200">倡导支持正版，推荐信息仅供参考</p>
        </div>
      </div>
    </footer>
  );
}